import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import type { CounterState } from "./useDashboardSubscription";

interface CounterCardProps {
  title: string;
  counterState: CounterState;
}

export function CounterCard({ title, counterState }: CounterCardProps) {
  return (
    <Box minWidth={300} flex={1}>
      <Card>
        <CardContent>
          <Typography variant="h6" mb={2}>
            {title}
          </Typography>

          <Typography variant="h3" textAlign="center" my={3}>
            {counterState.queuedCount}
          </Typography>
          <Typography variant="body2" textAlign="center" color="text.secondary" mb={3}>
            элементов в очереди
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
